module.exports = "/build/admin/images/commercetools.3ac54108.svg";